"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundImage = void 0;

var _fill = require("../../layout/fill");

var _styledTools = require("styled-tools");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/**
 * `StyledBackgroundImage` styled component.
 */


var StyledBackgroundImage = (0, _styledComponents.default)(_fill.Fill).withConfig({
  displayName: "background-image__StyledBackgroundImage",
  componentId: "sc-16wyug7-0"
})(["background-image:url(", ");background-position:", ";background-repeat:", ";background-size:", ";pointer-events:none;", ""], (0, _styledTools.prop)('defaultUrl'), (0, _styledTools.prop)('position', 'center'), (0, _styledTools.prop)('repeat', 'no-repeat'), (0, _styledTools.prop)('size', 'cover'), (0, _styledTools.ifProp)('retinaUrl', (0, _styledComponents.css)(["@media only screen and (-webkit-min-device-pixel-ratio:1.3),only screen and (min--moz-device-pixel-ratio:1.3),only screen and (-o-min-device-pixel-ratio:1.3/1),only screen and (min-resolution:144dpi),only screen and (min-resolution:1.5dppx):{background-image:url(", ");}"], (0, _styledTools.prop)('retinaUrl'))));
/**
 * Export `BackgroundImage` component.
 */

var BackgroundImage = function BackgroundImage(props) {
  return _react.default.createElement(StyledBackgroundImage, _extends({
    as: 'picture'
  }, props));
};

exports.BackgroundImage = BackgroundImage;